"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var EMPLOYER_BADGE_DEFAULT_ICON_IMAGE = 'https://stories-api-public.s3.amazonaws.com/employer-card-top.png';
exports.default = EMPLOYER_BADGE_DEFAULT_ICON_IMAGE;